import {useCallback} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useApi, useAlert} from "@/";
import {removeChannel, updateChannelIO} from "../../../../app/slices";
import {createIntegrationHandlers} from "../utils/integrationHandlers";

export const useChannelCallbacks = (setIntegratedChannels) => {
    const {callApi} = useApi();
    const dispatch = useDispatch();

    // Add a check to prevent accessing undefined properties
    const userId = useSelector((state) => state?.user?.user?._id || "");

    const handleRemoveChannel = useCallback(async (channelId) => {
        try {
            const res = await callApi("/user/deleteChannel", "DELETE", null, {
                channelId,
            });
            if (!res.success) {
                alert(
                    res.error.message ||
                    res.error ||
                    "An unexpected error occurred while removing the channel."
                );
                return;
            }
            alert("Channel removed successfully");
            dispatch(removeChannel(res.data._id));
            setIntegratedChannels((prev) =>
                prev.filter((channel) => channel.id !== channelId)
            );
        } catch (error) {
            console.error("Failed to remove channel:", error);
            alert(
                "Failed to remove channel::" +
                (error.message ||
                    error ||
                    "An unexpected error occurred while removing the channel.")
            );
        }
    }, [callApi, alert, dispatch, setIntegratedChannels]);

    const handleUpdateChannel = useCallback((channelId, updatedFields) => {
        setIntegratedChannels((prev) =>
            prev.map((channel) =>
                channel.id === channelId
                    ? {...channel, formFields: updatedFields}
                    : channel
            )
        );
    }, [setIntegratedChannels]);

    const integrationHandlers = createIntegrationHandlers(
        callApi,
        alert,
        dispatch,
        userId,
        updateChannelIO
    );

    const onIntegrate = useCallback((channelId, formData, setOpen) => {
        console.log("onIntegrate called");
        console.log(`Integrating ${channelId} with data:`, formData);

        switch (channelId) {
            case "shopify":
                integrationHandlers.handleShopifyIntegration(formData, setOpen);
                break;

            case "woocommerce":
                integrationHandlers.handleWooCommerceIntegration(formData, setOpen);
                break;

            case "amazon":
                integrationHandlers.handleAmazonIntegration(formData, setOpen);
                break;

            case "custom":
                integrationHandlers.handleCustomApiIntegration(formData, setOpen);
                break;

            default:
                console.warn(`No specific integration logic for ${channelId}`);
        }
    }, [integrationHandlers]);

    return {
        handleRemoveChannel,
        handleUpdateChannel,
        onIntegrate
    };
};